/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * [getEnvironment determines what enviornment the app is in via hostname ]
 * @returns {[string]} env
 */
export function getEnvironment() {
	const hostname = location.hostname;
	let env = '';
	switch (hostname) {
		case 'dev.hollywoodstudios.corp.adobe.com':
		case 'dev2.hollywoodstudios.corp.adobe.com':
			env = 'dev';
			break;
		case 'dev.creativecloud.adobe.com':
		case 'dev1.creativecloud.adobe.com':
		case 'dev2.creativecloud.adobe.com':
		case 'dev3.creativecloud.adobe.com':
		case 'dev4.creativecloud.adobe.com':
		case 'dev5.creativecloud.adobe.com':
		case 'dev6.creativecloud.adobe.com':
		case 'dev7.creativecloud.adobe.com':
		case 'dev8.creativecloud.adobe.com':
		case 'dev9.creativecloud.adobe.com':
		case 'dev10.creativecloud.adobe.com':
		case 'dev11.creativecloud.adobe.com':
		case 'dev12.creativecloud.adobe.com':
		case 'dev13.creativecloud.adobe.com':
		case 'dev14.creativecloud.adobe.com':
		case 'dev15.creativecloud.adobe.com':
		case 'devops.creativecloud.adobe.com':
		case 'dev1-oxford.creativecloud.adobe.com':
		case 'dev2-oxford.creativecloud.adobe.com':
			env = 'dev';
			break;
		case 'stage.creativecloud.adobe.com':
		case 'stage1.creativecloud.adobe.com':
		case 'stage2.creativecloud.adobe.com':
		case 'stage3.creativecloud.adobe.com':
		case 'stage1-oxford.creativecloud.adobe.com':
		case 'stage2-oxford.creativecloud.adobe.com':
		case 'stage.cc.adobe.com':
			env = 'stage';
			break;
		case 'creativecloud.adobe.com':
		case 'prod.creativecloud.adobe.com':
		case 'prod1.creativecloud.adobe.com':
		case 'prod2.creativecloud.adobe.com':
		case 'oxford.creativecloud.adobe.com':
		case 'prod2-oxford.creativecloud.adobe.com':
		case 'cc.adobe.com':
			env = 'prod';
			break;
		default:
			window.cchome.util.logger.error('Environment', 'No match for hostname, defaulting to prod', hostname);
			env = 'prod';
			break;
	}
	return env;
}
